import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { callApi, formatMoney, getInlineLoader } from "../Helpers";
import {
	STR_INDIVIDUALS,
	STR_GROUPS,
	STR_CREATE_NEW_CONTACT,
	STR_INVALID_NAME,
	STR_INVALID_PHONE,
	STR_INVALID_WHATSAPP_NUMBER,
	STR_SUCCESS,
	STR_NAME,
	STR_PHONE_NUMBER,
	STR_WHATSAPP_NUMBER,
	STR_OPTIONAL,
	STR_SUBMIT,
	STR_CREATE_NEW_CONTACT_GROUP,
	STR_DESCRIPTON
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdInfoOutline, MdMoney, MdOutlineMoneyOff, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup ,MdDownloading} from 'react-icons/md';
import { GiPayMoney } from "react-icons/gi";
import { TbMoneybag } from "react-icons/tb";
import { LiaMoneyCheckSolid } from "react-icons/lia";
import { GrMoney } from "react-icons/gr";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);
	const [name, setName] = useState("");
	const [description, setDescription] = useState("");
	

	async function init() {
		//run initializations here
		setReady(false);
		//..
		setReady(true);
	}

	function resetFields() {
		setName("");
		setDescription("");
	}

	async function createContactGroup() {
		if(name && name.trim().length > 0) {
			
			setLoading(true);
			await callApi(
				"create-contact-group",
				{
					name,
					description,
				}
			).then((response) => {
				if(response.status === 1) {
					appContext.tellMessage(STR_SUCCESS[appContext.language]);
					appContext.getAllContactGroups();
					resetFields();
				} else {
					appContext.tellError(response.msg);
				}
			})
			setLoading(false);
		} else {
			appContext.tellError(STR_INVALID_NAME[appContext.language]);
		}
	}


	useEffect(() => {
		init();
	}, [])


	useEffect(() => {
		appContext.setShowOverlayLoader(loading);
	}, [ loading ])

	if (ready) {
		return (
			<div
				className="container"
			>
			
				<div className="row">

					<div className="col-md-12">
						<h6
							className="mSectionTitle"
						>
							{STR_CREATE_NEW_CONTACT_GROUP[appContext.language]}
						</h6>
					</div>
					

					<div className="col-md-12">
						<div className="mb-3 mt-3">
							<label className="form-label">{STR_NAME[appContext.language]}</label>
							<input
								className="form-control"
								value={name}
								onChange={(e) => setName(e.target.value)}
							/>
						</div>

						<div className="mb-3 mt-3">
							<label className="form-label">{STR_DESCRIPTON[appContext.language]}</label>
							<textarea
								className="form-control"
								value={description}
								onChange={(e) => setDescription(e.target.value)}
							/>
							<div className="form-text">
								{STR_OPTIONAL[appContext.language]}
							</div>
						</div>

						<div className="mb-3 mt-3 text-end">
							<button
								className="btn btn-rounded bg-secondary btn-padded"
								onClick={createContactGroup}
							>
								{STR_SUBMIT[appContext.language]}
							</button>
						</div>

					</div>
				</div>
			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}